import React from 'react';

function Map() {
  return (
    <section id="mapa" className="container my-5">
      <h2 className="text-center mb-4">Localização</h2>
      <div className="row">
        <div className="col-12">
          <div className="ratio ratio-16x9 rounded overflow-hidden shadow-sm">
            <iframe 
              title="Localização"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3969.351255454512!2d-35.2219508!3d-5.805968599999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7b2555abb56c66d%3A0xb05ddd648f0047aa!2sVis%C3%A3o%20Positiva%20Natal!5e0!3m2!1spt-BR!2sbr!4v1739815790494!5m2!1spt-BR!2sbr"
              style={{ border: 0, width: "100%", height: "450px" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Map;
